import React from "react";

const PlatformNoticeModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative bg-white dark:bg-gray-900 text-black dark:text-white rounded-lg shadow-lg max-w-2xl w-[92%] mx-4 p-6 z-10">
        <h2 className="text-xl font-bold mb-3">Important notice about content</h2>
        <p className="text-sm mb-4 leading-relaxed text-black/[0.8] dark:text-white/[0.8]">
          The videos shown on this site are embedded from external platforms such as YouTube, Dailymotion and other public platforms. We do not host or redistribute the videos. Any advertisements, overlays, or promotional content that appear inside the embedded players are served by those platforms and are not controlled by us.
        </p>
        <p className="text-sm mb-4 leading-relaxed text-black/[0.8] dark:text-white/[0.8]">
          By using this site you agree that the embedded players are provided by third-party platforms and any content or ads displayed inside them are the responsibility of those platforms.
        </p>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700"
          >
            Close
          </button>

          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlatformNoticeModal;
